import { useLocation } from '@tanstack/react-router';
import { useMemo } from 'react';

import {
  getLocaleFromPathname,
  getLocaleMetadata,
  localizeHref,
  localizePath,
  stripLocaleFromPathname,
  type LocaleCode,
} from '@content';

export function useLocale() {
  const location = useLocation();
  const locale = getLocaleFromPathname(location.pathname);

  return useMemo(() => {
    const metadata = getLocaleMetadata(locale);

    return {
      locale,
      metadata,
      pathname: location.pathname,
      basePathname: stripLocaleFromPathname(location.pathname),
      localizePath: (pathname: string, targetLocale: LocaleCode = locale) => localizePath(pathname, targetLocale),
      localizeHref: (href: string, targetLocale: LocaleCode = locale) => localizeHref(href, targetLocale),
    };
  }, [locale, location.pathname]);
}
